// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__097LL","title":"ErrorBoundary_title__smSo9","description":"ErrorBoundary_description__qqx0O"};